import SinglePage, { Paragraph } from "../single-page/single-page";
import { email } from "../../envs";
import styled from "styled-components";
import buildings3 from "../../assets/buildings3.webp";
import { responsive } from "../../media-quries";
import { Helmet } from "react-helmet";

const Email = styled.a`
  font-size: 18px;
  font-weight: 600;
`;

const Container = styled.div`
  position: relative;
`;

const BuildingsImg = styled.img`
  position: absolute;
  right: -200px;
  top: -180px;
  width: 450px;

  ${responsive.sm`
    display: none;
  `}
`;

function Contact() {
    return (
        <SinglePage title="Kontakt z nami">
            <Helmet>
                <title>Kontakt z nami - geoksiegi.pl</title>
                <meta
                    name="description"
                    content="Skontaktuj się z nami pod adresem email. Jesteśmy gotowi odpowiedzieć na Twoje pytania dotyczące serwisu geoksiegi.pl."
                />
                <meta
                    name="keywords"
                    content="kontakt, geoksiegi, email, wsparcie, serwis, księgi wieczyste"
                />
            </Helmet>
            <Container>
                <Paragraph>
                    We wszelkich sprawach prosimy o kontakt pod adresem:
                </Paragraph>
                <Email href={`mailto:${email}`}>{email}</Email>
                <BuildingsImg src={buildings3} alt="Budynki" />
            </Container>
        </SinglePage>
    );
}

export default Contact;
